import './LandingPage.css'
import image from '../../assets/image.png'

function LandingPage({ onSignInButtonClicked }) {
    return (
        <div className='landing-page-root'>

            {/* ── TOP BAR ── */}
            <div className='top-bar'>
                <div className='top-bar-left'>
                    <div className='top-bar-logo'>
                        <h1>Kansodo</h1>
                    </div>
                </div>
                <div className='top-bar-right'>
                
                </div>
            </div>

            {/* ── HERO ── */}
            <div className='hero'>
                <div className='hero-badge'>
                    <span className='hero-badge-dot' />
                    Free to try
                </div>

                <div className='sub-heading'>
                    <h3>
                        Organise your tasks better<br />
                        <span className='accent'>by using nested lists</span>
                    </h3>
                </div>

                <div className='hero-cta'>
                    <button className='btn-primary' onClick={onSignInButtonClicked}>
                        Try Demo →
                    </button>
                    
                </div>
            </div>

            {/* ── PRODUCT IMAGE ── */}
            <div className='image-container'>
                <div className='image-frame'>
                    <img src={image} alt='Kansodo app screenshot' />
                </div>
            </div>

            {/* ── FOOTER ── */}
            <div className='footer'>
                <span className='footer-brand'>Kansodo</span>
                <span className='footer-contact'>
                    <a href='mailto:bikramankarmakar10@gmail.com'>Contact me</a>
                </span>
            </div>

        </div>
    )
}

export default LandingPage;
